import React from "react";
import { TentangKami, VisiMisi, Tim } from "../../components";

const Tentang = () => {
  return (
    <div className="pt-16">
      <TentangKami />
      <VisiMisi />
      <Tim />
    </div>
  );
};

export default Tentang;